import React, { useState, useEffect } from 'react';
import './carousel.css';
import Footer from '../footer/footer';
import Header from '../header/header';
import { useNavigate } from 'react-router-dom';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Location from '../locations/locations';
import Info from '../info/info';
import RatingPage from '../customers/cust';
import FullWidthImage from '../site/site';

const Homepage = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [titleText, setTitleText] = useState('Welcome to Dangoo Rentals');
    const navigate = useNavigate();

    const suggestions = [
        'Kimbo',
        'K-Road',
        'Juja',
        'Gate A',
        'Gate B',
        'Gate C',
        'Gate D',
        'Gashororo',
        'Oasis',
        'Weiteithie',
        'Gatundu Road',
    ];

    const handleSearch = () => {
        if (searchTerm) {
            console.log('Search:', searchTerm);
            navigate(`/${encodeURIComponent(searchTerm.toLowerCase())}`);
        }
    };

    const handleSuggestionChange = (selectedValue) => {
        setSearchTerm(selectedValue);
    };

    useEffect(() => {
        const phrases = ['Welcome to Dangoo Rentals', 'Exploring Houses ?', 'We Got You...'];
        let currentIndex = 0;
        let letterIndex = 0;

        const interval = setInterval(() => {
            if (letterIndex === phrases[currentIndex].length) {
                letterIndex = 0;
                currentIndex = (currentIndex + 1) % phrases.length;
            }
            setTitleText(phrases[currentIndex].substring(0, letterIndex + 1));
            letterIndex++;
        }, 300);

        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <Header />
            <section className="section1 carousel">
            <div className="overlay">
    <div className="content">
        <div className="overlay-h2-container"> 
            <h2 className="overlay-h2">{titleText}</h2>
        </div>
        <p className="overlay-p">Find your perfect place to stay</p>
        <div className="search-bar">
            <select
                value={searchTerm}
                onChange={(e) => handleSuggestionChange(e.target.value)}
                className="form-control"
            >
                <option value="" disabled>Select an option</option>
                {suggestions.map((suggestion, index) => (
                    <option key={index} value={suggestion}>
                        {suggestion}
                    </option>
                ))}
            </select>
            <button className="search-icon" onClick={handleSearch}>
                <FontAwesomeIcon icon={faSearch} />
            </button>
        </div>
    </div>
</div>

            </section>
            
            <Info />
            <Location />
            <FullWidthImage />
            <RatingPage />
            <Footer />
        </div>
    );
};

export default Homepage;
